import { render, staticRenderFns } from "./DebtorEditAccount.vue?vue&type=template&id=18641a9b&"
import script from "./DebtorEditAccount.vue?vue&type=script&lang=js&"
export * from "./DebtorEditAccount.vue?vue&type=script&lang=js&"
import style0 from "./DebtorEditAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports